import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const PoolIcon = observer('PoolIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            width='24'
            height='24'
            viewBox='0 0 50 50'
            fill='#061A32'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            onClick={onClick}
        >
            <path
                d='M36.51,30.37l-7.42-14.84c-.79-1.59-2.32-2.53-4.09-2.53s-3.3.95-4.09,2.53l-7.42,14.84c-.71,1.43-.64,3.1.2,4.46.84,1.36,2.3,2.17,3.89,2.17h14.84c1.6,0,3.05-.81,3.89-2.17s.92-3.03.2-4.46h0ZM25.03,15.24c1.71,0,3.1,1.4,3.1,3.11s-1.39,3.11-3.1,3.11-3.1-1.4-3.1-3.11,1.39-3.11,3.1-3.11ZM17.87,35.02c-1.71,0-3.1-1.4-3.1-3.11s1.39-3.11,3.1-3.11,3.1,1.4,3.1,3.11-1.39,3.11-3.1,3.11ZM18.33,25c0-1.72,1.39-3.11,3.1-3.11s3.1,1.4,3.1,3.11-1.39,3.11-3.1,3.11-3.1-1.4-3.1-3.11ZM25.02,35.02c-1.71,0-3.1-1.4-3.1-3.11s1.39-3.11,3.1-3.11,3.1,1.4,3.1,3.11-1.39,3.11-3.1,3.11ZM25.48,25c0-1.72,1.39-3.11,3.1-3.11s3.1,1.4,3.1,3.11-1.39,3.11-3.1,3.11-3.1-1.4-3.1-3.11ZM32.14,35.02c-1.71,0-3.1-1.4-3.1-3.11s1.39-3.11,3.1-3.11,3.1,1.4,3.1,3.11-1.39,3.11-3.1,3.11Z'
                fill='fill'
            />
            <path
                d='M25.03,20.83c1.36,0,2.46-1.11,2.46-2.48s-1.11-2.48-2.46-2.48-2.46,1.11-2.46,2.48,1.11,2.48,2.46,2.48Z'
                fill='fill'
            />
            <path
                d='M23.89,25c0,1.37-1.1,2.48-2.46,2.48s-2.46-1.11-2.46-2.48,1.1-2.48,2.46-2.48,2.46,1.11,2.46,2.48'
                fill='fill'
            />
            <path
                d='M31.04,25c0,1.37-1.1,2.48-2.46,2.48s-2.46-1.11-2.46-2.48,1.1-2.48,2.46-2.48,2.46,1.11,2.46,2.48'
                fill='fill'
            />
            <path
                d='M17.87,29.43c-1.36,0-2.46,1.11-2.46,2.48s1.11,2.48,2.46,2.48,2.46-1.11,2.46-2.48-1.11-2.48-2.46-2.48Z'
                fill='fill'
            />
            <path
                d='M25.02,29.43c-1.36,0-2.46,1.11-2.46,2.48s1.11,2.48,2.46,2.48,2.46-1.11,2.46-2.48-1.11-2.48-2.46-2.48Z'
                fill='fill'
            />
            <path
                d='M32.14,29.43c-1.36,0-2.46,1.11-2.46,2.48s1.11,2.48,2.46,2.48,2.46-1.11,2.46-2.48-1.11-2.48-2.46-2.48Z'
                fill='fill'
            />
        </SvgIcon>
    );
});
